// extracted by mini-css-extract-plugin
module.exports = {"Link":"RedSocialLink_Link__kbBTm"};